import { ENDPOINTS_ENUM, getEndpoint } from "common/backend/endpoints"
import axios from 'axios'

export const getPublicBudgetToken = async (shortUrl) => {
    try {
        const publicShortenEndpoint = getEndpoint(ENDPOINTS_ENUM.PUBLIC_SHORT)
        const res = await axios.get(`${publicShortenEndpoint}${shortUrl}`)
        const token = res.data.metaData.token

        return token
    } catch (err) {
      return Promise.reject(err)
    }
}

export default getPublicBudgetToken
